import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { BrandingProvider } from './context/BrandingContext';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import AccountSuspended from './pages/AccountSuspended'; // 👈 NEW IMPORT
import BidMapSnapshot from './pages/print/BidMapSnapshot';

// Components
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import SuperAdminRoute from './components/SuperAdminRoute';

function App() {
  return (
    <AuthProvider>
      <BrandingProvider>
        <Router>
          <Routes>
            {/* === PUBLIC ROUTES === */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            {/* 👇 NEW: Account Suspended Route */}
            <Route path="/account-suspended" element={<AccountSuspended />} />

            {/* === HEADLESS PRINT ROUTE (Puppeteer-only, token-verified server-side) === */}
            <Route path="/print/bid-map/:bidId" element={<BidMapSnapshot />} />

            {/* === FARMER ROUTE (Standard Private) === */}
            <Route path="/dashboard" element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } />

            {/* === ADMIN ROUTE (Allows Admin & SuperAdmin) === */}
            <Route path="/admin" element={
              <AdminRoute>
                 <AdminDashboard />
              </AdminRoute>
            } />

            {/* === SUPERADMIN ROUTE (Strictly SuperAdmin) === */}
            <Route path="/superadmin" element={
              <SuperAdminRoute>
                 <SuperAdminDashboard />
              </SuperAdminRoute>
            } />

            {/* Default Redirect */}
            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Routes>
        </Router>
      </BrandingProvider>
    </AuthProvider>
  );
}

export default App;